import script from "./StarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./StarButton.vue?vue&type=script&setup=true&lang=js"

import "./StarButton.vue?vue&type=style&index=0&id=58310181&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58310181"]])

export default __exports__